module.exports = __webpack_public_path__ + "img/album21_11.41c2d84e.jpg";